import { SavedSearchName } from '@aibees/elephant/components';
import { SearchBrowseParams } from '@aibees/elephant/types';
import { TextEllipsis } from '@aibees/shared/components';
import { ParsedPreset } from '@aibees/shared/definition';
import { AdvanceTableConfig } from '@aibees/shared/features';
import {
  DATE_FORMAT_DD_MMM_YYYY,
  fDateShort,
  userGetShortName,
} from '@aibees/shared/utils';
import { CardBodyDate } from '../../styles';
import { SaveSearchTableAction } from './actions/save-search-table-action';
import * as SX from './sx';

export const config: Omit<
  AdvanceTableConfig<ParsedPreset<SearchBrowseParams>>,
  'browseApi'
> = {
  columns: [
    {
      id: 'name',
      label: 'Name',
      sortable: true,
      width: 132,
      render: (_, v) => <SavedSearchName value={v} showAsLink />,
    },
    {
      id: 'user',
      label: 'Team',
      sortable: true,
      width: 70,
      render: (_, v) => (
        <TextEllipsis
          value={userGetShortName(v.workspace.user)}
          variant="body4"
          color="grey.700"
        />
      ),
    },
    {
      id: 'modified',
      label: 'Created',
      sortable: true,
      width: 132,
      render: (v) => (
        <CardBodyDate>{fDateShort(v, DATE_FORMAT_DD_MMM_YYYY)}</CardBodyDate>
      ),
    },
  ],
  actions: [SaveSearchTableAction],
  filters: [],
  actionsConfig: {
    label: 'Action',
    minWidth: '10%',
    align: 'center',
    sx: { display: 'flex', justifyContent: 'center' },
  },
  hidePagination: true,
  stickyHeader: true,
  defaultOrderBy: 'modified',
  hideColumnsOnNoData: true,
  emptyProps: {
    emptyIcon: 'bookmark',
    emptyIconWrapperSX: SX.emptyIconWrapper,
    titleSx: { fontSize: 14 },
    iconSize: 28,
  },

  hideResetFilters: true,
  cellSx: { p: 1 },
  bordered: 'solid',
};
